// extracted by mini-css-extract-plugin
export default {"enrichmentSaveToButton":"enrichment-save-to-button_enrichmentSaveToButton__wWofn","disabled":"enrichment-save-to-button_disabled__AS8gM"};